import { useContext, useEffect, useRef, useState } from "react";
import { GetPDFFileList, GetSearchData, GetPDFWithFilename } from "../CRUDPage/FetchData";
import FilterContexts from "../../Variables/FilterContexts";

const pdfTypeList = ["OCT_G", "OCT_M", "AL", "VF"]

const ListODOSImages = ({records, client_id}) => {
    // console.log(records)
    const imageTypeRef = useRef(null);
    const {updateFunc} = useContext(FilterContexts)
    return(<>
        <select name="selectPDF" ref={imageTypeRef} onChange={(event) => {updateFunc("pdfType", event.target.value)}}>
            {pdfTypeList.map((type) => (<option value={type}>{type}</option>))}
        </select>
        <GetPatientRecord records={records} client_id={client_id}></GetPatientRecord>
    </>)
}

export default ListODOSImages;

const GetPatientRecord = ({records, client_id}) => {
    const {datas} = useContext(FilterContexts);
    if(!datas.pdfType)return(<></>)
    // /eye_record/${client_id} -> record_id
    let allPatientRecord = records ? records : GetSearchData("eye_record/"+client_id);
    // let allPatientRecord = records;
    // console.log(records)
    if(!Array.isArray(allPatientRecord))return<div>loading dates...</div>
    
    return(
        <div>
            <table>
                    <td className=" font-bold">
                        <tr className="h-16"><td>date</td></tr>
                        <tr className="h-48"><td>OD</td></tr>
                        <tr><td>OS</td></tr>
                    </td>
                    {allPatientRecord.map(record => (
                        <GetFilesForDays record_id={record.record_id} test_date={record.test_date}></GetFilesForDays>
                    ))}
            </table>
        </div>
    )
}

const GetFilesForDays = ({record_id, test_date}) => {
    const {datas} = useContext(FilterContexts);
    let [pdfFiles, setPDFfiles] = useState(null);
    // forEach(record_id) -> /test_pdf/{record_id}/{imageTypeRef} -> push({${record_id}:{test_date, filenames}})
    useEffect(() => {
        try{
            GetPDFFileList(`test_pdf/${record_id}/${datas.pdfType}`)
            .then(response => {
                setPDFfiles(response)
            })
            .catch(error => {
                console.log("error when get filenames",error);
            })
        }
        catch(error){
            console.log("error when GetPDFFileList",error);
        }
    }, [datas])
    // if(!pdfFiles)return<div>loading images...</div>
    // filter filenames, if has OD / OS -> use previewFile in AddPDF.jsx
    return(
        pdfFiles && pdfFiles.filenames.length>0 ? 
        <td className=" text-center pl-2">
            <tr className="flex justify-center text-center"><td>{test_date}</td></tr>
            <tr className="flex">
                {pdfFiles.filenames.map(fileName => (
                    (fileName.includes("OD")) ? <ShowImages fetchUrl={`test_pdf/${record_id}/${datas.pdfType}/${fileName}`} filename={fileName}></ShowImages> : <></>
                ))}
            </tr>
            <tr className="flex">
                {pdfFiles.filenames.map(fileName => (
                    (fileName.includes("OS")) ? <ShowImages fetchUrl={`test_pdf/${record_id}/${datas.pdfType}/${fileName}`} filename={fileName}></ShowImages> : <></>
                ))}
            </tr>
        </td>
         : <></>
    )
}

const ShowImages = ({fetchUrl, filename}) => {
    // test_pdf/{eye_record_record_id}/{file_type}/{filename}
    let [imageURL, setImageURL] = useState(null);

    useEffect(() => {
        try{
            GetPDFWithFilename(fetchUrl)
            .then(response => {
                const url = URL.createObjectURL(response);
                setImageURL(url);
                // console.log(url)
            })
            .catch(error => {
                console.log("error when get image file",error);
            })
        }
        catch(error){
            console.log("error when GetPDFWithFilename", error);
        }
    }, [])

    return(
        imageURL ? 
        <div>
            <div className=" text-xl">{filename}</div>
            <img src={imageURL} alt={filename} className="h-40"></img>
        </div>
        : <></>
    )
}
